export default __webpack_public_path__ + "static/media/robot1.60bd05df.png";